var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarePrioritiesOther(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 261 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_105_35490",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 261,
    height: 147
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.822 144.134C156.362 149.129 189.665 145.812 214.783 136.387C239.881 126.969 256.927 111.398 259.679 91.8162C262.431 72.2343 250.337 52.5681 228.807 36.5972C207.26 20.6134 176.162 8.24528 140.622 3.2504C105.081 -1.74447 71.7787 1.57272 46.6603 10.9981C21.5622 20.4158 4.51589 35.9867 1.76383 55.5685C-0.988218 75.1504 11.1058 94.8167 32.6358 110.788C54.1832 126.771 85.2813 139.139 120.822 144.134Z",
    fill: "#F5F9FE",
    stroke: "#E1E1E1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_105_35490)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_105_35490)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.722,
    cy: 73.6924,
    rx: 129.725,
    ry: 70.6342,
    transform: "rotate(8 130.722 73.6924)",
    fill: "#F5F9FE"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.8405 156.63C69.8405 156.63 38.307 119.111 47.7528 109.515C57.1986 99.9202 73.0748 110.394 70.3547 99.6944C67.6345 88.9945 56.8061 78.6142 61.1798 70.4955C66.436 60.7474 81.8188 68.6577 89.2671 72.0692C103.114 78.4127 118.449 79.1179 113.14 70.2453C107.832 61.3728 93.9014 52.7017 98.9526 47.6435C105.838 40.7615 143.614 66.2225 159.786 86.1875C169.468 98.1276 176.52 89.8178 175.54 82.1473C174.918 77.2837 168.061 67.2091 175.255 62.6581C182.186 58.2705 198.378 71.8712 203.881 80.2713C218.281 102.262 194.703 156.418 194.703 156.418L69.8405 156.63Z",
    fill: "#C5CEDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.473 68.9877V87.8133H83.1772V52.6565H131.473V68.9877Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.8257,
    y: 58.7846,
    width: 42.744,
    height: 3.0189,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.476 55.8109V58.7846H83.1772V53.2332H131.476V55.8109Z",
    fill: "#4A90E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7584 52.99H88.7322V88.39H83.1772V52.99H85.7584Z",
    fill: "#055CC0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.6489 88.9146H132.327V52.4655H82.6489V88.9146ZM131.274 87.8724H83.6911L83.705 53.5181H131.274V87.8724Z",
    fill: "#0134A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.6489 88.9146H132.327V52.4655H82.6489V88.9146ZM131.274 87.8724H83.6911L83.705 53.5181H131.274V87.8724Z",
    fill: "#0134A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.5913,
    y: 64.5341,
    width: 37.0571,
    height: 4.20353,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.5913,
    y: 68.7376,
    width: 37.0571,
    height: 4.20354,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.5913,
    y: 72.903,
    width: 37.0571,
    height: 4.20353,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.5913,
    y: 77.11,
    width: 37.0571,
    height: 4.20355,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.5913,
    y: 81.2718,
    width: 37.0571,
    height: 4.20354,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.0859,
    y: 88.39,
    width: 68.3682,
    height: 2.939,
    fill: "#0134A0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.0859,
    y: 88.39,
    width: 68.3682,
    height: 2.939,
    fill: "#0134A0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.709,
    cy: 109.654,
    rx: 3.91867,
    ry: 3.91866,
    fill: "#AB9AF7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.94,
    cy: 108.88,
    rx: 4.62389,
    ry: 4.62389,
    fill: "#AB9AF7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.944,
    cy: 108.88,
    rx: 4.62389,
    ry: 4.62389,
    fill: "#AB9AF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.797 104.256L154.571 108.88V109.109C154.449 111.569 152.421 113.503 149.958 113.507H134.947C132.481 113.506 130.449 111.572 130.326 109.109V108.88L130.101 104.256L154.797 104.256Z",
    fill: "#AB9AF7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.7524,
    y: 90.5682,
    width: 128.534,
    height: 3.672,
    fill: "#0134A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3579 156.383H72.0046L78.4975 97.1723L78.8379 93.9067H75.2285L70.3579 156.383Z",
    fill: "#0134A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.561 81.1711L182.905 84.4332L189.398 143.644H191.045L186.174 81.1711H182.561Z",
    fill: "#0134A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.069 75.7725H129.398V74.5983H124.069V75.7725ZM129.308 75.6683H124.187L124.174 74.706H129.308V75.6683Z",
    fill: "#055CC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.834 149.251C145.733 150.317 145.084 151.335 141.825 152.145L138.236 153.159C136.903 153.534 135.51 153.646 134.134 153.489C131.226 153.159 127.297 152.426 125.761 153.302C120.807 156.119 120.144 152.169 120.043 151.592L115.28 112.058C114.909 109.946 115.666 108.098 117.142 106.424C118.679 104.712 120.674 103.477 122.892 102.866C127.408 101.574 136.868 99.0969 138.74 100.393C151.847 109.474 137.698 123.967 139.233 131.891C140.505 138.436 144.177 145.263 145.414 147.441C145.739 147.986 145.886 148.619 145.834 149.251Z",
    fill: "#658FDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.237 82.1855L145.41 87.3096L145.021 91.3395H143.646H141.617L118.355 91.3464L119.237 82.1855Z",
    fill: "#C9DEF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.021 91.336L145.41 87.3096L143.649 86.9622V91.336H145.021Z",
    fill: "#C9DEF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.646 61.9911H149.993V48.4669C149.993 44.3533 146.658 41.0186 142.544 41.0186C138.57 41.0186 134.961 44.1452 134.766 48.1056L134.266 58.4442C134.223 59.3684 134.56 60.2699 135.198 60.9397C135.837 61.6094 136.721 61.9893 137.646 61.9911Z",
    fill: "#E6BBA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.876 72.6702H143.805C142.079 72.6702 140.679 71.2704 140.679 69.5436V58.5519H149.982V69.554C149.982 71.2808 148.582 72.6806 146.855 72.6806L146.876 72.6702Z",
    fill: "#E6BBA6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.341,
    cy: 68.0185,
    rx: 4.65169,
    ry: 4.65168,
    fill: "#E6BBA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7651 77.9229H121.652",
    stroke: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7651 82.2202H121.652",
    stroke: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7651 73.629H121.652",
    stroke: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7651 69.3317H121.652",
    stroke: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.906 104.256C156.909 105.841 156.604 107.411 156.009 108.88H133.091C131.233 104.26 132.33 98.9757 135.873 95.4773C139.417 91.9788 144.715 90.9502 149.31 92.8683C153.906 94.7863 156.9 99.2761 156.906 104.256Z",
    fill: "#AB9AF7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 144.545,
    cy: 104.256,
    rx: 3.38714,
    ry: 3.38715,
    fill: "#40327A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.755,
    cy: 86.6958,
    r: 4.62042,
    transform: "rotate(-4.7 170.755 86.6958)",
    fill: "#C9DEF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.857 77.8603L168.12 90.5022L174.067 83.4813L158.577 67.5669L149.857 77.8603Z",
    fill: "#C9DEF6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.708,
    cy: 72.3072,
    rx: 6.77776,
    ry: 6.77777,
    transform: "rotate(-18.74 153.708 72.3072)",
    fill: "#C9DEF6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.544,
    cy: 90.8809,
    rx: 2.70972,
    ry: 2.70972,
    fill: "#FF95A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.015 89.6928C146.827 90.6399 145.996 91.3224 145.031 91.3231C144.065 91.3239 143.233 90.6427 143.043 89.6959C142.853 88.749 143.358 87.7998 144.25 87.4283C145.141 87.0568 146.171 87.3663 146.71 88.1677C147.01 88.6153 147.12 89.164 147.015 89.6928Z",
    fill: "#FF95A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.297 93.2883L144.087 91.1102L145.411 87.3096L150.062 88.2198L148.297 93.2883Z",
    fill: "#FF95A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.888 87.6084C122.459 89.7718 120.562 91.3311 118.357 91.3329C116.151 91.3347 114.251 89.7786 113.819 87.6158C113.386 85.4531 114.541 83.286 116.578 82.4394C118.615 81.5927 120.966 82.3024 122.194 84.1344C122.878 85.1541 123.128 86.4041 122.888 87.6084Z",
    fill: "#C9DEF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.234 77.8569L120.985 90.5161L115.03 83.5021L130.507 67.5704L139.234 77.8569Z",
    fill: "#C9DEF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.237 77.8569L124.084 88.3692L117.66 80.7959L130.504 67.5704L139.237 77.8569Z",
    fill: "#C9DEF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.857 77.8603L165.021 88.3553L171.437 80.7785L158.577 67.5669L149.857 77.8603Z",
    fill: "#C9DEF6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.368,
    cy: 72.2723,
    rx: 6.77776,
    ry: 6.77776,
    transform: "rotate(-62.12 135.368 72.2723)",
    fill: "#C9DEF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.64 71.701L158.99 105.479H134.28L132.622 71.7114C132.559 70.4148 133.029 69.1487 133.924 68.2081C134.818 67.2675 136.059 66.7344 137.357 66.7332H155.905C157.204 66.7324 158.446 67.2649 159.341 68.2059C160.236 69.147 160.706 70.4143 160.64 71.7114V71.701Z",
    fill: "#C9DEF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.08 104.423L172.153 156.369H173.887L161.561 104.423H157.08Z",
    fill: "#0134A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.315 104.423L126.241 156.369H124.507L136.837 104.423H141.315Z",
    fill: "#0134A0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.197,
    cy: 97.016,
    rx: 25.388,
    ry: 25.388,
    fill: "#000B64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.314 81.0321H145.094C144.639 81.0356 144.202 80.8552 143.882 80.5318C143.552 80.2141 143.363 79.7775 143.357 79.3194C143.357 78.3716 144.126 77.6033 145.074 77.6033H153.307C153.762 77.6023 154.199 77.783 154.52 78.1051C154.842 78.4273 155.021 78.8643 155.02 79.3194C155.02 80.2653 154.253 81.0321 153.307 81.0321H153.314Z",
    fill: "#C9DEF6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.977,
    y: 62.9152,
    width: 12.159,
    height: 3.8075,
    fill: "#C9DEF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.74 55.4774H136.708V51.4198H138.74C139.86 51.4217 140.767 52.3289 140.769 53.4486C140.769 54.5691 139.861 55.4774 138.74 55.4774Z",
    fill: "#E6BBA6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 93.4427,
    cy: 80.8133,
    rx: 0.955351,
    ry: 0.955345,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.341 45.1006C132.343 46.3416 132.908 47.5149 133.877 48.2898C134.847 49.0646 136.116 49.3573 137.326 49.0852C139.31 48.6579 140.665 46.8758 140.8 44.8574C140.964 42.6305 143.208 39.7437 141.037 39.7437C140.015 39.7437 137.782 39.3719 134.176 41.7655C133.228 42.3741 132.578 43.3497 132.379 44.4579C132.349 44.6707 132.337 44.8856 132.341 45.1006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 146.202,
    cy: 45.375,
    rx: 8.36539,
    ry: 7.14601,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.708 46.2331C136.708 46.2331 145.369 56.9643 142.444 66.344C139.518 75.7238 147.071 69.8528 150.257 75.7725C153.484 81.7755 166.338 75.9531 161.96 69.3317C157.583 62.7102 154.568 45.3611 154.568 45.3611",
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.7737,
    cy: 68.6508,
    rx: 1.3757,
    ry: 1.3757,
    fill: "#E6E6E8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.7737,
    cy: 72.9481,
    rx: 1.3757,
    ry: 1.3757,
    fill: "#E6E6E8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.7737,
    cy: 77.2455,
    r: 1.3757,
    fill: "#8896AA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.7737,
    cy: 81.5393,
    rx: 1.3757,
    ry: 1.37569,
    fill: "#E6E6E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2285 76.9571L95.9094 77.7909L97.5283 75.8871",
    stroke: "#055CC0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7739 67.7267L96.0344 68.2548L96.6146 68.3416L96.1942 68.7515L96.295 69.3317L95.7739 69.0573L95.2528 69.3317L95.35 68.7515L94.9297 68.3416L95.5133 68.2548L95.7739 67.7267Z",
    fill: "#055CC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7739 72.1039L96.0344 72.632L96.6146 72.7154L96.1942 73.1253L96.295 73.7055L95.7739 73.431L95.2528 73.7055L95.35 73.1253L94.9297 72.7154L95.5133 72.632L95.7739 72.1039Z",
    fill: "#055CC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7739 80.7403L96.0344 81.2683L96.6146 81.3517L96.1942 81.7617L96.295 82.3418L95.7739 82.0674L95.2528 82.3418L95.35 81.7617L94.9297 81.3517L95.5133 81.2683L95.7739 80.7403Z",
    fill: "#055CC0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_105_35490",
    x: 1.87695,
    y: 1.43558,
    width: 257.689,
    height: 147.514,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_105_35490"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_105_35490"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarePrioritiesOther);
export default __webpack_public_path__ + "static/media/Care Priorities - Other.c5066853038373b91201d33e2be0c71e.svg";
export { ForwardRef as ReactComponent };